import { useEffect, useRef, useState } from 'react';
import { handleTrack } from '../../../../../utils/tracker';
import { VideoPlayBtn } from '../../../../Icons/videoPlayBtn';
import { THandleNext } from '../../data/product-guide.data';
import { HorizontalTab } from '../HorizontalTab';

interface IVideoTabSection {
  video: string;
  handleNext: THandleNext;
  thumbnail: string;
}

export const VideoTabSection = ({
  video,
  handleNext,
  thumbnail,
}: IVideoTabSection) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayVideo = () => {
    videoRef.current?.play();
    videoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    handleTrack({
      label: `play_video`,
      url: video,
    });
  };

  useEffect(() => {
    const videoElement = videoRef.current;

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    videoElement?.addEventListener('play', handlePlay);
    videoElement?.addEventListener('pause', handlePause);

    return () => {
      videoElement?.removeEventListener('play', handlePlay);
      videoElement?.removeEventListener('pause', handlePause);
    };
  }, []);

  return (
    <div>
      <div className="bg-grey-700">
        <div onClick={() => handlePlayVideo()}>
          <div
            className={`videoContainer relative bottom-0 w-full sm:w-full flex items-center justify-center xl:h-[456px] lg:h-80 md:h-60 sm:h-52 overflow-hidden`}
          >
            {!isPlaying && <VideoPlayBtn />}
            <video
              role="video"
              preload="auto"
              ref={videoRef}
              src={video}
              controls={true}
              autoPlay
              poster={thumbnail}
              playsInline
              className="w-3/4 sm:w-full"
              onEnded={handleNext}
              loop={false}
            />
          </div>
        </div>
      </div>
      <HorizontalTab />
    </div>
  );
};
